import { Component, Input, OnInit } from "@angular/core";
import { DynamicPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { SessionComponent } from '../../component';
import { FormData, TabularData } from 'src/app/framework-modules/formdata/form/formData';
import { MessageService } from 'src/app/services/messageService';
import { SubjectForm, SubjectFd } from 'src/app/framework-modules/formdata/gen/subjectForm';
import { MatDialog } from '@angular/material';
import { CtDialogComponent } from 'src/app/framework-modules/elements/ct-dialog/component';

@Component({
  selector: "subject-edit",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})

export class SubjectEditComponent implements DynamicPanel, OnInit {
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;

  public form: SubjectForm;
  public fd: SubjectFd;
  public child: TabularData;
  public childSubjects: FormData[];
  public subjectTypes: string[] = ["Theory", "Practical"];
  public showChildren = false;

  constructor(private sa: ServiceAgent, private ms: MessageService, private dialog: MatDialog) {
    this.form = SubjectForm.getInstance();
    this.fd = new FormData(this.form, this.sa);
  }

  ngOnInit() {
    this.fd.setFieldValue('subjectId', this.inputData);
    this.fd.fetchData().subscribe({
      next: vo => {
        this.child = this.fd.getChildTable('childSubjects');
        this.childSubjects = this.child.childData as FormData[];
        this.showChildren = this.fd.getFieldValue('isIntegrated') as boolean;
      }
    });
  }

  /**
   * To check if subject type selected is Integrated
   */
  checkIntegrated() {
    this.child.removeRow(0);
    this.child.removeRow(1);
    this.showChildren = false;
    if (this.fd.getFieldValue('subjectTypeId') == 4) {
      this.child.appendRow();
      this.child.appendRow();
      this.showChildren = true;
    }
    this.fd.setFieldValue('isIntegrated', this.showChildren);
  }

  /**
   * Set Required Fields to child with data from parent
   */
  setValuesToChild() {

    this.childSubjects.forEach((element: SubjectFd, index) => {
      element.setFieldValue('departmentId', this.fd.getFieldValue('departmentId'));
      element.setFieldValue('code', this.fd.getFieldValue('code'));
      element.setFieldValue('isActive', this.fd.getFieldValue('isActive'));
      element.setFieldValue('isElective', this.fd.getFieldValue('isElective'));
      element.setFieldValue('isExamsRequired', this.fd.getFieldValue('isExamsRequired'));
      element.setFieldValue('isPrintedInHallticket', this.fd.getFieldValue('isPrintedInHallticket'));
      /**
       * Check if the subject needs exams
       */
      if(this.fd.getFieldValue('isExamsRequired')){
        element.setFieldValue('gradingSchemeId',1);
      }
      else{
        element.setFieldValue('gradingSchemeId',2);
      }
      /**
       * TO set values for theory integrated
       */
      if (index == 0) {
        element.setFieldValue('name', this.fd.getFieldValue('name') + ' - Lecture');
        element.setFieldValue('lectureCredits', this.fd.getFieldValue('lectureCredits'));
        element.setFieldValue('totalCredits', this.fd.getFieldValue('lectureCredits'));
        element.setFieldValue('subjectTypeId', 1);
      }
      /**
       * TO set values for practical Integrated
       */
      else {
        element.setFieldValue('name', this.fd.getFieldValue('name') + ' - Practcal');
        element.setFieldValue('lectureCredits', this.fd.getFieldValue('practicalCredits'));
        element.setFieldValue('totalCredits', this.fd.getFieldValue('practicalCredits'));
        element.setFieldValue('subjectTypeId', 2);
      }

    })
  }

  creditsChanged() {
    this.fd.setFieldValue('totalCredits', +this.fd.getFieldValue('practicalCredits') + +this.fd.getFieldValue('lectureCredits') + +this.fd.getFieldValue('tutorialCredits'))
  }

  /**
 * Adds a new subject to the institute
 */
  doEditSubject() {
    if (this.fd.getFieldValue('subjectTypeId') == 4) {
      this.setValuesToChild()
    }
    if(this.fd.getFieldValue('isExamsRequired')){
      this.fd.setFieldValue('gradingSchemeId',1);
    }
    else{
      this.fd.setFieldValue('gradingSchemeId',2);
    }
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Save Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to save changes?';
    dialogRef.componentInstance.primary = 'Save';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.fd.save().subscribe({
        next: vo => {
          this.ms.showSuccess("Subject " + this.fd.getFieldValue('name') + " updated Successfully!")
          this.parentPanel.navigate("SubjectList");
        },
        error: err => {
          this.ms.showError(err);
        }
      });
    });

  }

  doCancel() {
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Discard Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to discard changes?';
    dialogRef.componentInstance.primary = 'Discard';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.parentPanel.navigate("SubjectList");
    });
  }

}